import { LOAD_TENDER_TYPES_SUCCESS, RESET_TENDER_TYPES } from '../../../../actions/types';

const INITIAL_STATE = []

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOAD_TENDER_TYPES_SUCCESS:
            return action.payload;
        case RESET_TENDER_TYPES:
            return INITIAL_STATE;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/restaurants/settings/service/TenderTypesReducer.js